<template>
  <select :disabled="disable" :class="inputClass">
    <slot />
  </select>
</template>

<script>
import { init, destroy, trigger, clear } from './utils'

export default {
  props: ['options', 'value', 'change', 'selection', 'disable', 'inputClass'],
  mounted() {
    init(this.$el, this.options, this.change)
  },
  watch: {
    options(item) {
      init(this.$el, item, this.change)
    },
    selection(item) {
      let { id, text } = item
      if (id === '') {
        clear(this.$el)
      } else {
        trigger(this.$el, this.options, this.change, id, text)
      }
    }
  },

  destroyed() {
    destroy(this.$el)
  }
}
</script>
